import axios from 'axios'
import { PartnerAgreementSignatory } from '../../interfaces'

export const generateAgreement = (signatory: PartnerAgreementSignatory, partnerId: string) => {
  return axios.post('/api/v1/sp_izdruka/' + partnerId, signatory, { responseType: 'blob' })
}
